// VIP product variant ID for membership
const vipProductVariantId = 46535546044583;
// const shipInsureProductId = 46574933246119;
const sellingPlanId = 2507505831;
let vipUpsellBlock = `
<div class="upcart-products-section">
<div class="vip_subscription_block">
  <div class="membership-upsell-cart">
    <h4 class="membership-heading">MEMBERS GET AN EXTRA 15% OFF</h4>
    <div class="perc-off">
      <img class="memb-img" src="https://cdn.shopify.com/s/files/1/0176/7018/files/Icons-Percent.png?v=1735048273">
      <div style="display:inline-block">
        <p class="nrm-details">Free 30d trial.</p>
      </div>
    </div>
    <div class="stor-cred">
      <img class="memb-img" src="https://cdn.shopify.com/s/files/1/0176/7018/files/Icons-Cycle.png?v=1735048272">
      <div style="display:inline-block;">
        <p class="nrm-details">15% off today.</p>
        <p class="savings-today">After your 30-day free trial, it's $47/mo.</p>
      </div>
    </div>
    <div class="month-cred">
      <img class="memb-img" src="https://cdn.shopify.com/s/files/1/0176/7018/files/Icons-Dollar.png?v=1735048272">
      <div style="display:inline-block;">
        <p class="nrm-details">You get $47 credit each month.</p>
        <p class="savings-today">Use within 12m.</p>
      </div>
    </div>
    <div class="membership--button" data-type="from-cart">
      <button class="mem-btn add-to-cart" id="addVipCartBtn">Save 15%</button>
    </div>
  </div>
</div>
</div>
`;

// Cache management utilities
const MB_CACHE_KEYS = {
  PRODUCT_DATA: "mb_product_data",
  PRODUCT_TIMESTAMP: "mb_product_timestamp",
};

const MB_CACHE_DURATIONS = {
  PRODUCT: 60 * 60 * 1000, // 1 hour in milliseconds
};

function isCacheValid(timestamp, duration) {
  if (!timestamp) return false;
  const now = Date.now();
  return now - timestamp < duration;
}

function getCachedData(key, timestampKey) {
  try {
    const data = localStorage.getItem(key);
    const timestamp = localStorage.getItem(timestampKey);

    if (data && timestamp) {
      const duration = MB_CACHE_DURATIONS.PRODUCT;
      if (isCacheValid(parseInt(timestamp), duration)) {
        return JSON.parse(data);
      }
    }
  } catch (error) {
    console.error("Error reading from cache:", error);
  }
  return null;
}

function setCachedData(key, timestampKey, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    localStorage.setItem(timestampKey, Date.now().toString());
  } catch (error) {
    console.error("Error writing to cache:", error);
  }
}

// Simple cart data fetching function - always fresh data
let cartPromise = null;

function getCartData() {
  // Return existing promise if a request is already in progress
  if (cartPromise) {
    return cartPromise;
  }

  // Create new promise for cart data using Shopify's /cart.js API
  cartPromise = fetch("/cart.js")
    .then(function (response) {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(function (cartData) {
      return cartData;
    })
    .catch(function (error) {
      console.error("Error fetching cart data:", error);
      // Return default USD data on error
      return { currency: "USD" };
    })
    .finally(function () {
      // Reset promise so next call fetches fresh data
      cartPromise = null;
    });

  return cartPromise;
}

// Product data caching function
function getProductData() {
  // Check localStorage cache first
  const cachedData = getCachedData(
    MB_CACHE_KEYS.PRODUCT_DATA,
    MB_CACHE_KEYS.PRODUCT_TIMESTAMP
  );
  if (cachedData) {
    return Promise.resolve(cachedData);
  }

  // Fetch fresh data if not cached
  return fetch("https://carrotstick.com/products/inveterate-subscription.json")
    .then((response) => response.json())
    .then((data) => {
      // Cache the response
      setCachedData(
        MB_CACHE_KEYS.PRODUCT_DATA,
        MB_CACHE_KEYS.PRODUCT_TIMESTAMP,
        data
      );
      return data;
    })
    .catch((error) => {
      console.error("Error fetching product data:", error);
      throw error;
    });
}

function removeFreeDeluxeGiftText() {
  const subscriptionElements = $(".upcart-item-property");

  subscriptionElements.each(function () {
    const $element = $(this);
    const currentText = $element.text();

    // Only remove "Free deluxe gift." if it exists and hasn't been removed already
    if (
      currentText.includes("Free deluxe gift.") ||
      currentText.includes("Free deluxe gift")
    ) {
      const updatedText = currentText.replace("Free deluxe gift.", "").trim();
      $element.text(updatedText);
    }
  });
}

function updateVIPMembershipText() {
  const vipMembershipElements = $('h3:contains("VIP Membership")')
    .closest(".styles_ProductRow__productTitleAndVariant__")
    .find(".upcart-item-property.upcart-item-property-subscription");

  // Only update if the text hasn't been changed already
  vipMembershipElements.each(function () {
    const $element = $(this);
    if ($element.text().trim() !== "Change or Cancel anytime.") {
      $element.text("Change or Cancel anytime.");
    }
  });
}

// <p class="savings-today">Use within 12m. Pause or cancel online</p>
// Add VIP Product from Membership Page.
$(document).on("click", ".membership--button", function (e) {
  e.preventDefault();

  const $button = $(this);
  const type = $(this).data("type");

  // Preserve button width
  const originalText = $button.text().trim();
  const originalWidth = $button.outerWidth();
  $button.css("width", originalWidth + "px");

  // Disable the button and show loading spinner
  $button.prop("disabled", true);
  $button.html('<span class="spinner"></span>');

  // Add basic inline spinner (you can use a class-based loader instead)
  const spinnerCSS = `
      <style>
        .spinner {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 2px solid #fff;
          border-top: 2px solid #000;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          vertical-align: middle;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>`;
  if (!$("head").hasClass("spinner-style-added")) {
    $("head").append(spinnerCSS).addClass("spinner-style-added");
  }

  // Check if the VIP product is already in the cart
  fetch("/cart.json")
    .then((response) => response.json())
    .then((cartData) => {
      const isProductInCart = cartData.items.some(
        (item) => item.id === vipProductVariantId
      );

      if (isProductInCart) {
        window.upcartRefreshCart();
        window.upcartOpenCart();
      } else {
        const payload = {
          items: [
            {
              id: vipProductVariantId,
              quantity: 1,
            },
          ],
        };

        payload.items[0].selling_plan = sellingPlanId;

        $("input[name='selling_plan']").val("");
        $.ajax({
          url: "/cart/add.js",
          method: "POST",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify(payload),
          success: function () {
            // Update the attributes using update AJAX API
            const updatePayload = {
              attributes: {
                location: type,
              },
            };
            $.ajax({
              url: "/cart/update.js",
              method: "POST",
              contentType: "application/json",
              dataType: "json",
              data: JSON.stringify(updatePayload),
              error: function (xhr, status, error) {
                console.error("Error adding product to cart:", error);
                // Re-enable the button and restore text if there's an error
                $button.prop("disabled", false).html(originalText);
              },
            });

            window.upcartRefreshCart();
            window.upcartOpenCart();
            updateVIPMembershipText();

            $button.prop("disabled", false).html(originalText);
          },
          error: function (xhr, status, error) {
            console.error("Error adding product to cart:", error);
            // Re-enable the button and restore text if there's an error
            $button.prop("disabled", false).html(originalText);
          },
        });
      }
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
      $button.prop("disabled", false).html(originalText);
    });
});

document.addEventListener("DOMContentLoaded", async function () {
  const cartResBk = await fetch("/cart.js");
  const cartDataBk = await cartResBk.json();

  // For VIP Product change the below text.
  updateVIPMembershipText();

  // Remove Free deluxe gift text from cart.
  removeFreeDeluxeGiftText();

  // When any item is added to cart, conditionally auto-add VIP if the checkbox is selected
  // Add VIP Product from the Buy Box
  window.upcartSubscribeAddedToCart(async ({ item }) => {
    const cartRes1 = await fetch("/cart.js");
    const cartData1 = await cartRes1.json();

    const vipOption = document.getElementById(
      "purchaseTypeOneTime-78508997674631"
    );

    // For VIP Product change the below text.
    updateVIPMembershipText();

    if (vipOption && vipOption.checked) {
      try {
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();

        const isVipAlreadyInCart = cartData.items.some(
          (cartItem) => cartItem.variant_id === vipProductVariantId
        );

        if (!isVipAlreadyInCart) {
          const payload = {
            items: [
              {
                id: vipProductVariantId,
                quantity: 1,
              },
            ],
          };

          payload.items[0].selling_plan = sellingPlanId;

          // If the VIP Member checkbox is checked then add the VIP Product in cart
          $.ajax({
            url: "/cart/add.js",
            method: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify(payload),
            success: function () {
              // Update the attributes using update AJAX API
              const updatePayload = {
                attributes: {
                  location: "from-buy-box",
                },
              };

              $.ajax({
                url: "/cart/update.js",
                method: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(updatePayload),
                error: function (xhr, status, error) {
                  console.error("Error adding product to cart:", error);
                },
              });

              // Remove Free deluxe gift text from cart.
              removeFreeDeluxeGiftText();
              window.upcartRefreshCart();
              window.upcartOpenCart();
            },
            error: function (xhr, status, error) {
              console.error("Error adding product to cart:", error);
            },
          });

          // Remove Free deluxe gift text from cart.
          removeFreeDeluxeGiftText();
          window.upcartRefreshCart();
        }
      } catch (error) {
        console.error("Error processing VIP product logic:", error);
      }
    }
  });

  // Remove custom attribute from cart item when item is removed from cart
  window.upcartSubscribeItemRemoved(({ item }) => {
    if (item.variantId == vipProductVariantId) {
      const removeAttributesPayload = {
        attributes: {
          location: "",
        },
      };

      $.ajax({
        url: "/cart/update.js",
        method: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(removeAttributesPayload),
        error: function (xhr, status, error) {
          console.error("Error removing custom attribute from cart:", error);
        },
      });
    }
  });

  // Hide quantity stepper for VIP product on cart load
  window.upcartSubscribeCartLoaded(({ cart }) => {
    const productTitles = document.querySelectorAll(".upcart-product-title");

    // For VIP Product change the below text.
    updateVIPMembershipText();

    // Remove Free deluxe gift text from cart.
    removeFreeDeluxeGiftText();

    productTitles.forEach((titleEl) => {
      if (titleEl.textContent.trim() === "VIP Membership") {
        const productRow =
          titleEl.closest(".upcart-product-item") ||
          titleEl.closest(".Stack__item");

        if (productRow) {
          const quantityWrapper = productRow.querySelector(
            ".styles_ProductRow__stepper__"
          );
          if (quantityWrapper) {
            quantityWrapper.style.display = "none";
          }
        }
      }
    });

    // Show VIP block dynamically with formatted price based on region
    getCartData().then(function (cartData) {
      const currencySymbol = getCurrencySymbol(cartData.currency);
      // Use cached product data
      getProductData()
        .then((data) => {
          const formattedPrice = formatProductPrice(
            data.product.variants[0].price
          );

          // Create a fresh copy of the original HTML template each time
          let currentVipUpsellBlock = `
<div class="upcart-products-section">
<div class="vip_subscription_block">
  <div class="membership-upsell-cart">
    <h4 class="membership-heading">MEMBERS GET AN EXTRA 15% OFF</h4>
    <div class="perc-off">
      <img class="memb-img" src="https://cdn.shopify.com/s/files/1/0176/7018/files/Icons-Percent.png?v=1735048273">
      <div style="display:inline-block">
        <p class="nrm-details">Free 30d trial.</p>
      </div>
    </div>
    <div class="stor-cred">
      <img class="memb-img" src="https://cdn.shopify.com/s/files/1/0176/7018/files/Icons-Cycle.png?v=1735048272">
      <div style="display:inline-block;">
        <p class="nrm-details">15% off today.</p>
        <p class="savings-today">After your 30-day free trial, it's $47/mo.</p>
      </div>
    </div>
    <div class="month-cred">
      <img class="memb-img" src="https://cdn.shopify.com/s/files/1/0176/7018/files/Icons-Dollar.png?v=1735048272">
      <div style="display:inline-block;">
        <p class="nrm-details">You get $47 credit each month.</p>
        <p class="savings-today">Use within 12m.</p>
      </div>
    </div>
    <div class="membership--button" data-type="from-cart">
      <button class="mem-btn add-to-cart" id="addVipCartBtn">Save 15%</button>
    </div>
  </div>
</div>
</div>
`;

          // Safely replace all instances of $47 or $47.00 with the correct formatted price
          currentVipUpsellBlock = currentVipUpsellBlock.replace(
            /\$47(\.00)?/g,
            currencySymbol + formattedPrice
          );

          fetch("/cart.js")
            .then((res) => res.json())
            .then((cartData) => {
              const cartState = analyzeCartState(cartData);
              handleVipBlockDisplay(cartState, currentVipUpsellBlock);
            });
        })
        .catch((error) => {
          console.error("Error loading product data:", error);
        });
    });

    // Helper function to get currency symbol based on currency code
    function getCurrencySymbol(currency) {
      const currencyMap = {
        INR: "INR",
        AUD: "A$",
        EUR: "€",
        GBP: "£",
        CAD: "C$",
        USD: "$",
      };
      return currencyMap[currency] || "$";
    }

    // Helper function to format product price
    function formatProductPrice(price) {
      const rawPrice = parseFloat(price);
      return rawPrice % 1 === 0 ? rawPrice.toFixed(0) : rawPrice.toFixed(2);
    }

    // Helper function to analyze cart state
    function analyzeCartState(cartData) {
      const isVipInCart = cartData.items.some(
        (item) => item.variant_id === vipProductVariantId
      );

      const hasSellingPlan = cartData.items.some((item) => {
        return (
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan
        );
      });

      const hasNonSellingPlanItem = cartData.items.some((item) => {
        return !(
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan
        );
      });
        const onlyGiftCardInCart =
        cartData.items.length > 0 &&
        cartData.items.every(
          (item) => item.product_title === "CS Gift Card"
        );
      const vipBlockExists = jQuery(".vip_subscription_block").length > 0;

      return {
        isVipInCart,
        hasSellingPlan,
        hasNonSellingPlanItem,
        onlyGiftCardInCart,
        vipBlockExists,
      };
    }

    // Helper function to handle VIP block display logic
    function handleVipBlockDisplay(cartState, currentVipUpsellBlock) {
      const {
        isVipInCart,
        hasSellingPlan,
        hasNonSellingPlanItem,
        onlyGiftCardInCart,
        vipBlockExists,
      } = cartState;

      //Hide upsell if ONLY gift card is in cart
      if (onlyGiftCardInCart) {
        jQuery(".vip_subscription_block").remove();
        return;
      }

      if (
        !isVipInCart &&
        !vipBlockExists &&
        hasNonSellingPlanItem &&
        !hasSellingPlan
      ) {
        jQuery("#up-upsell-carousel").before(currentVipUpsellBlock);
        window.upcartRefreshCart();
      } else if (!isVipInCart && vipBlockExists && hasSellingPlan) {
        jQuery(".vip_subscription_block").remove();
        window.upcartRefreshCart();
      } else if (isVipInCart && vipBlockExists && !hasNonSellingPlanItem) {
        jQuery(".vip_subscription_block").remove();
        window.upcartRefreshCart();
      } else if (isVipInCart && vipBlockExists) {
        // Remove VIP block if VIP is already in cart
        jQuery(".vip_subscription_block").remove();
        window.upcartRefreshCart();
      } else if (!hasNonSellingPlanItem && vipBlockExists) {
        // Remove VIP block if cart has only selling plan items
        jQuery(".vip_subscription_block").remove();
        window.upcartRefreshCart();
      }
    }
  });

  window.upcartSubscribeCartLoaded(({ cart }) => {
    // Remove Free deluxe gift text from cart.
    setTimeout(() => {
      removeFreeDeluxeGiftText();
    }, 100);
  });

  window.upcartSubscribeCartLoaded(({ cart }) => {
    const intervalId = setInterval(() => {
      removeFreeDeluxeGiftText();
    }, 1000);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  });

  window.upcartSubscribeAddedToCart(({ item }) => {
    // Remove Free deluxe gift text from cart.
    setTimeout(() => {
      removeFreeDeluxeGiftText();
    }, 100);
  });

  window.upcartSubscribeAddedToCart(({ item }) => {
    const intervalId = setInterval(() => {
      removeFreeDeluxeGiftText();
    }, 1000);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  });

  window.upcartSubscribeCartUpdated(({ cart }) => {
    removeFreeDeluxeGiftText();
    setTimeout(() => {
      removeFreeDeluxeGiftText();
    }, 100);
  });

  window.upcartSubscribeCartOpened(() => {
    removeFreeDeluxeGiftText();
    setTimeout(() => {
      removeFreeDeluxeGiftText();
    }, 100);
  });
});

setTimeout(() => {
  $("#profile_nav_item").after(
    '<li><a id="manage_membership" href="/community/membership" class="manage_btn MuiButtonBase-root MuiListItemButton-root MuiListItemButton-gutters css-13e5dn5">Manage Membership</a></li>'
  );

  $("#manage_membership").after(
    '<li><a id="manage_returns" href="https://carrotstick.returnscenter.com" class="manage_btn MuiButtonBase-root MuiListItemButton-root MuiListItemButton-gutters css-13e5dn5">Manage Returns</a></li>'
  );
}, 5000);
